import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import partnerCss from './style.css';

const TRANSLATE_PREFIX = 'STATIC.PAGES.PARTNER_SIGNUP';

export const BLOCKING_NOT_WORKING = 'not_working';
export const BLOCKING_HAS_INTEGRATION = 'has_integration';

export default function BlockingPage({ type, onGoBack }) {
    const isNotWorking = type === BLOCKING_NOT_WORKING;
    const titleKey = isNotWorking
        ? `${TRANSLATE_PREFIX}.BLOCKING_NOT_WORKING_TITLE`
        : `${TRANSLATE_PREFIX}.BLOCKING_HAS_INTEGRATION_TITLE`;
    const textKey = isNotWorking
        ? `${TRANSLATE_PREFIX}.BLOCKING_NOT_WORKING_TEXT`
        : `${TRANSLATE_PREFIX}.BLOCKING_HAS_INTEGRATION_TEXT`;

    return (
        <div className={partnerCss.blockingPage}>
            <div className={partnerCss.blockingTitle}>
                <Translate id={titleKey} />
            </div>
            <div className={partnerCss.blockingText}>
                <Translate id={textKey} />
            </div>
            <div className={partnerCss.blockingActions}>
                <button
                    type="button"
                    className={partnerCss.blockingLinkSecondary}
                    onClick={onGoBack}
                >
                    <Translate id={`${TRANSLATE_PREFIX}.BLOCKING_GO_BACK`} />
                </button>
                {!isNotWorking && (
                    <a
                        href="https://support.singular.net/hc/en-us/requests/new?ticket_form_id=43407712940315"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={partnerCss.blockingLinkPrimary}
                    >
                        <Translate id={`${TRANSLATE_PREFIX}.BLOCKING_CONTACT_SUPPORT`} />
                    </a>
                )}
            </div>
        </div>
    );
}

BlockingPage.propTypes = {
    type: PropTypes.string.isRequired,
    onGoBack: PropTypes.func.isRequired,
};